import {UPDATE_CLIENT} from '../client';
import {ClientService} from '../../services';
import {campaignsActions} from '../campaigns';
import {usersActions} from '../users';

export const SET_SETTINGS = 'SET_SETTINGS';

export const settingsActions = {
  setSettings,
  submitSettings,
};

function setSettings(setting: any) {
  return (dispatch: any, getState: any) => {
    const client = getState().client.data;
    if (client) {
      const clientId = client.id;
      const settings = getState().settings;
      settings[clientId] = {...settings[clientId], ...setting};
      dispatch({type: SET_SETTINGS, settings});
    }
  };
}

function submitSettings(attrs: any) {
  return async (dispatch: any, getState: any) => {
    const prepareEmails = emails => {
      return emails
        .split(',')
        .map(email => email.trim())
        .filter(email => email)
        .join(',');
    };
    const updatedAttrs = {...attrs};
    if (typeof attrs.exclude_companies !== 'undefined') {
      updatedAttrs.exclude_companies = attrs.exclude_companies || null;
    }
    if (typeof attrs.estimated_lead_value !== 'undefined') {
      updatedAttrs.estimated_lead_value = attrs.estimated_lead_value || null;
    }
    if (typeof attrs.kpi !== 'undefined') {
      updatedAttrs.kpi = attrs.kpi || null;
    }
    if (typeof attrs.hot_lead_report_emails !== 'undefined') {
      updatedAttrs.hot_lead_report_emails = attrs.hot_lead_report_emails ? prepareEmails(attrs.hot_lead_report_emails) : null;
    }
    const oldClient = getState().client.data;
    const updatedClient = await ClientService.updateAttribute(updatedAttrs);
    dispatch({type: UPDATE_CLIENT, updatedClient});
    // reload page if timezone changed
    if (attrs.timezone && attrs.timezone !== oldClient.timezone) {
      dispatch(campaignsActions.getCampaigns(oldClient.id));
      dispatch(usersActions.getUsers(oldClient.id));
      return;
    }
    return updatedClient;
  };
}
